MOVE.LDP.CrabWalk = (function(LDP) {
  var pageIndex,
    totalCount;

  var init = function() {
    var prevPropLink = $('.ldp-pager .prev'),
      nextPropLink = $('.ldp-pager .next'),
      propLinks = MOVE.Helper.getPropertyLinksFromStorage(),
      criteria = MOVE.Helper.getSearchCriteriaFromCookie(),
      is_crawalk_disable = MOVE.DOMHelper.isCrabwalkDisable();

    if(is_crawalk_disable) {
      MOVE.DOMHelper.enableCrabwalk();
      return;
    }
    if (criteria && propLinks) {
      var linkIndex = matchedPropertyIndex(propLinks.links, MOVE.LDP.model.getData().canonical);

      if (linkIndex >= 0) {
        $('.ldp-pager').removeClass('hide');
        pageIndex = propLinks.pageIndex ? parseInt(propLinks.pageIndex, 10) : 1;
        totalCount = propLinks.totalCount;
        var pageSize = criteria.pgsz ? criteria.pgsz : 20,
          lastIndex = propLinks.links.length - 1,
          totalPage = Math.ceil(totalCount / pageSize);
        /*

        Next Link Initiator:

        Case 1: If the Link Index is the last in the SRP result set and page Index is
         equal to total page.
        Case 2: If the Link Index is gt, eq 0
        */
        if (linkIndex === lastIndex && pageIndex === totalPage) {
          // We have reached the last next page of crab walk, not do anything
          disablePropLink(nextPropLink);
        } else if (linkIndex >= 0) {
          initPropLink(nextPropLink, propLinks.links[linkIndex + 1]);
        }

        /*

        Previous Link Initiator:

        Case 1: If the Link Index in the SRP Array list is not first initiate it.
        Case 2: If the Link Index in the SRP Array list is first and the SRP Result set
        Page index is not equal to 1.
        */
        if (linkIndex !== 0) {
          initPropLink(prevPropLink, propLinks.links[linkIndex - 1]);
        } else if (linkIndex === 0 && pageIndex !== 1) {
          initPropLink(prevPropLink);
        }

      }
      else{
        if(MOVE_DATA.propertyDetails.status_display == "Off Market"){
          $('.ldp-pager').addClass('hide');
        }
      }
    }
  };

  var disablePropLink = function($link) {
    $link.addClass('disabled');
  };

  var initPropLink = function($link, link) {
    $link.removeClass('disabled');
    if (link) {
      $link.attr('href', link);
    }
    $link.click(propLinkClicked);
  };

  var matchedPropertyIndex = function(propLinks, url){
    return _.findIndex(propLinks, function(link) {
      var walker = link.split('?');
      if (walker.length > 1) {
        // The possible query params for LDP are listing id
        return url.includes(walker[0]) && (walker[1].includes(MOVE.LDP.model.getData().listing_id) || MOVE.LDP.model.getData().canonical.includes(walker[0]));
      } else {
        return url.includes(link);
      }
    });
  };

  var propLinkClicked = function() {
    var href = $(this).attr('href');
    if (href === '#') {
      getNextSetProperties($(this));
      return false;
    } else {
      window.location.href = href;
    }
  };

  var getNextSetProperties = function($link) {
    var isNextLink = $link.attr('class') === 'next';
    pageIndex = isNextLink ? pageIndex + 1 : pageIndex - 1;
    $.ajax({
      url: "/next_set_properties",
      method: "GET",
      data: {
        page_index: pageIndex
      },
      dataType: 'json',
      success: function(response) {
        if (response) {
          if (response.propLinks.length > 0){
            // Multi listings are added at the end of response.
            // Remove them from the list at the end to make sure crab walk works as expected.
            var propertyLinks = _.uniq(response.propLinks, function(propLink){
                                  return propLink.split('?')[0]; });
            MOVE.Helper.setPropertyLinksToStorage(propertyLinks, totalCount, pageIndex);
            var index = isNextLink ? 0 : propertyLinks.length - 1;
            window.location.href = '/realestateandhomes-detail/' + propertyLinks[index];
          }
        }
      }
    });

  };

  LDP.CrabWalk = {
    init: init
  };

  return LDP.CrabWalk;

})(MOVE.LDP || {});



// WEBPACK FOOTER //
// ./ldp/common_platform/critical_components/_crab_walk.js